import { takeLatest, put, all, call } from "redux-saga/effects";
import { FETCH_HOME_PAGE_WIDGET } from "@reducers/actionTypes";

import { actions } from "@reducers/homeWidgetReducer";

import { api, getHomePageWidgetData, getHomePageWidgets } from "@services/api";

function* fetchHomePageWidgetData() {
  try {
    const homePageWidget = yield call(getHomePageWidgets);
    yield put(actions.setHomePageWidget(homePageWidget?.data?.widgets));
    if (homePageWidget?.data?.one_time_data) {
      const homePageWidgetData = yield call(getHomePageWidgetData);
      yield put(actions.updateHomePageWidget(homePageWidgetData?.data));
    }
    yield all(
      Object.keys(homePageWidget?.data?.widgets).map(function* (key) {
        const item = homePageWidget?.data?.widgets[key];
        if (item?.api && !item?.one_time_data) {
          try {
            const apiData = yield call(api, item.api);
            yield put(actions.updateHomePageWidget(apiData?.data));
          } catch (error) {}
        }
      }),
    );
  } catch (e) {}
}

export default function* homeWidgetSaga() {
  yield all([takeLatest(FETCH_HOME_PAGE_WIDGET, fetchHomePageWidgetData)]);
}
